const productionApi = "https://apigis.mea.or.th";

export const getMapserviceStyles = (apikey, service) => {
  return fetch(
    `${productionApi}/${process.env.REACT_APP_API_V}/mapservices/${service}/styles`,

    {
      method: "GET",
      headers: {
        "API-Key": apikey,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      return error;
    });
};

export const getSeviceList = (apikey) => {
  return fetch(
    `${productionApi}/${process.env.REACT_APP_API_V}/services?category=map`,

    {
      method: "GET",
      headers: {
        "API-Key": apikey,
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => response.json())
    .then((result) => result)
    .catch((error) => {
      return error;
    });
};
